import { AnimatedSection } from '@denqfabrik/landing-ui';
import { useTranslation } from '../../i18n';

export default function ProofBar() {
  const { t } = useTranslation();
  const { badges } = t.proofBar;

  return (
    <section data-nav-theme="light" className="bg-[#f2f5fa] py-6 sm:py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            {badges.map((badge, i) => (
              <div
                key={i}
                className="flex items-center gap-2 rounded-full border border-[#dce2eb] bg-white px-4 py-2 shadow-sm sm:px-5 sm:py-2.5"
              >
                <span className="text-lg">{badge.icon}</span>
                <span className="text-xs font-semibold text-slate-700 sm:text-sm">
                  {badge.text}
                </span>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
